<template>
  <div class="container">

    <Loading :active.sync="isLoading"
             :can-cancel="false"
             :is-full-page="false"></Loading>

    <div class="row">
      <div class="col-md-12 mt-2 mb-3">
        <h1>
          <span>Wild Orchid Listing</span>
        </h1>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">

        <!--                current step: {{event.currentFormStep}}<br/>-->
        <!--                {{errors}}-->

        <div>


          <div class="row">
            <div class="col-md-12">

              <b-form-group
                  label="Site"
                  label-for="site"
                  :class="{'is-invalid': errors.has('site')}">

                <v-select
                    v-model="site"
                    placeholder="site"
                    id="site"
                    name="site"
                    :options="sitesOptions"
                    label="name"
                    v-validate="'required'"
                >
                  <span slot="no-options">No results.</span>
                  <template slot="option" slot-scope="item">
                    {{ item.name }}
                  </template>
                  <template slot="selected-option" slot-scope="item">
                    {{ item.name }}
                  </template>

                </v-select>
                <div class="invalid-feedback" v-if="errors.has('site')">
                  This field is required.
                </div>
              </b-form-group>

              <div @click.stop="showOrchidsPicker">
                <b-form-group
                    label="Select spotted orchid species"
                    label-for="species"
                    :class="{'is-invalid': errors.has('species')}">

                  <v-select
                      v-model="species"
                      placeholder="species"
                      id="species"
                      name="species"
                      :options="speciesOptions"
                      label="name"
                      :disabled="true"
                      v-validate="'required'"
                  >
                    <span slot="no-options">No results.</span>
                    <template slot="option" slot-scope="item">
                      {{ item.name }}
                    </template>
                    <template slot="selected-option" slot-scope="item">
                      {{ item.name }}
                    </template>

                  </v-select>
                  <div class="invalid-feedback" v-if="errors.has('species')">
                    This field is required.
                  </div>
                </b-form-group>
              </div>

              <b-form-group
                  label="Height in centimetres"
                  label-for="height"
                  :class="{'is-invalid': errors.has('height')}">

                <b-input-group append="cm">
                  <b-form-input
                      id="height"
                      name="height"
                      v-model="height"
                      type="number"
                      min="1"
                      max="100"
                      placeholder="height in centimetres"
                      v-validate="'required'"
                      trim></b-form-input>
                </b-input-group>

                <div class="invalid-feedback" v-if="errors.has('height')">
                  This field is required.
                </div>
              </b-form-group>

              <b-form-group
                  label="Number of specimen"
                  label-for="count"
                  :class="{'is-invalid': errors.has('count')}">

                <b-input-group append="specimen">
                  <b-form-input
                      id="count"
                      name="count"
                      v-model="count"
                      type="number"
                      min="1"
                      max="100"
                      placeholder="number of specimen"
                      v-validate="'required'"
                      trim></b-form-input>
                </b-input-group>

                <div class="invalid-feedback" v-if="errors.has('height')">
                  This field is required.
                </div>
              </b-form-group>

              <b-form-group
                  label="Colour"
                  label-for="color"
                  :class="{'is-invalid': errors.has('color')}">

                <v-select
                    v-model="color"
                    placeholder="colour"
                    id="color"
                    name="color"
                    :options="getColorsOptions"
                    label="name"
                    v-validate="'required'"
                >
                  <span slot="no-options">No results.</span>
                  <template slot="option" slot-scope="item">
                    {{ item.name }}
                  </template>
                  <template slot="selected-option" slot-scope="item">
                    {{ item.name }}
                  </template>

                </v-select>
                <div class="invalid-feedback" v-if="errors.has('color')">
                  This field is required.
                </div>
              </b-form-group>

              <b-card class="bg-light mt-4 mb-3">

                <b-button class="mb-3 d-block w-100" variant="primary" @click="getCurrentPosition">Get Current
                  Position Inforamtion
                </b-button>

                <b-form-group
                    label="Location - latitude"
                    label-for="latitude"
                    :class="{'is-invalid': errors.has('latitude')}">

                  <b-form-input
                      id="latitude"
                      name="latitude"
                      v-model="latitude"
                      placeholder="location - latitude"
                      v-validate="'required'"
                      trim></b-form-input>

                  <div class="invalid-feedback" v-if="errors.has('latitude')">
                    This field is required.
                  </div>
                </b-form-group>

                <b-form-group
                    label="Location - longitude"
                    label-for="longitude"
                    :class="{'is-invalid': errors.has('longitude')}">

                  <b-form-input
                      id="longitude"
                      name="longitude"
                      v-model="longitude"
                      placeholder="location - longitude"
                      v-validate="'required'"
                      trim></b-form-input>

                  <div class="invalid-feedback" v-if="errors.has('longitude')">
                    This field is required.
                  </div>
                </b-form-group>

              </b-card>

              <b-form-group
                  label="Photo"
                  label-for="photo"
                  :class="{'is-invalid': errors.has('imageName')}">

                <b-input-group>
                <b-form-input
                    id="imageName"
                    name="imageName"
                    v-model="imageName"
                    placeholder="photo"
                    v-validate="'required'"
                    @click="pickFile"
                    trim></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="pickFile"><i class="fa fa-camera"></i></b-button>
                  </b-input-group-append>
                </b-input-group>

                <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="onFilePicked"
                >

                <div v-if="imageUrl" class="w-100 my-1 text-center" style="margin: 0px auto;">
                  <img :src="imageUrl" class="img-fluid" style="max-height: 200px; margin: 0px auto;">
                </div>

                <div class="invalid-feedback" v-if="errors.has('imageName')">
                  This field is required.
                </div>
              </b-form-group>

              <b-form-group
                  label="Comment"
                  label-for="comment"
              >
                <textarea v-model="comment" id="comment" name="comment"
                          placeholder="comment" class="form-control"
                          style="height: auto"
                          required rows="5"> </textarea>
              </b-form-group>

            </div>
          </div>

        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-md-12 mt-3">

        <div class="d-flex">
          <button type="submit" @click="saveData()" class="btn btn-info d-block w-100"><i
              class="fa fa-save"></i> Submit data
          </button>
        </div>

        <div>
          <a @click="clearData()" class="btn btn-link py-4">
            Clear data
          </a>
        </div>
      </div>
    </div>


    <b-modal ref="orchidsPickerModal" title="Orchids" size="lg">

      <div class="row">
        <div class="col-md-12 mt-5">
          <br/>

          <div v-for="(orchid, index) in speciesOptions" :key="'orchid_' + index" class="mb-4">
            <b-card
                :title="orchid.name"
                :img-src="orchid.image"
                img-top
                tag="div"
            >
              <b-card-text>
                <em>{{ orchid.latinName }}</em><br/>
                <small class="pt-2 text-muted text-lowercase">{{ orchid.siName }}</small>
              </b-card-text>

              <b-button block href="#" variant="primary"
                        @click="() => { species = speciesOptions[index]; $refs['orchidsPickerModal'].hide(); }">Select
              </b-button>
            </b-card>
          </div>

        </div>
      </div>


      <div slot="modal-footer" class="w-100">
        <b-button
            variant="primary"
            class="float-right"
            @click="() => { $refs['orchidsPickerModal'].hide(); }">
          Close
        </b-button>
      </div>


    </b-modal>

  </div>
</template>

<style type="text/css" scoped>
.navbar-toggler {
  display: none !important;
}

.navbar-brand {
  margin: 0px auto !important;
  padding: 0px;
}

.modal-dialog {
  margin: 0px !important;
  padding: 0px !important;
  border: none !important;
  border-radius: 0px !important;
}

.modal-backdrop {
  background-color: #fff;
}

.modal-content {
  border-radius: 0px !important;
  border: none !important;
}

.modal-header {
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: 999;
  background-color: #fff !important;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.18);
}
</style>


<script>
import firebase from 'firebase'
import {db} from '../main'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import DeviceUUID from 'device-uuid';
import Loading from 'vue-loading-overlay';

export default {
  name: 'EditEvent',
  components: {
    vSelect,
    Multiselect,
    Loading
  },
  data() {
    return {
      isLoading: false,
      editMode: false,

      id: this.$route.params.id,
      createdAt: null,

      site: null,
      species: null,
      height: null,
      color: null,
      count: null,
      latitude: null,
      longitude: null,
      comment: null,
      deviceUuid: null,
      photo: null,

      imageName: null,
      imageFile: null,
      imageUrl: null,

      sitesOptions: [
        {
          id: 1,
          name: "dry grassland",
          siName: 'suh travnik',
        },
        {
          id: 2,
          name: "humid grassland",
          siName: 'mokroten travnik',
        },
        {
          id: 3,
          name: "forest",
          siName: 'gozd',
        },
        {
          id: 4,
          name: "forest edge",
          siName: 'rob gozda',
        },
        {
          id: 5,
          name: "long a forest path",
          siName: 'ob gozdni poti',
        },
        {
          id: 6,
          name: "along a meadow path",
          siName: 'ob kolovozu na travniku',
        },
        {
          id: 7,
          name: "along a paved road",
          siName: 'ob cesti',
        }
      ],
      speciesOptions: [
        {
          id: 1,
          name: 'Adriatic lizard orchid',
          siName: 'JADRANSKA SMRDLJIVA KUKAVICA',
          latinName: 'Himantoglossum adriaticum',
          image: 'https://adi.dobra-pot.si/orchids/1_adriatic_lizard_orchid.jpg'
        },
        {
          id: 2,
          name: 'Bee orchid',
          siName: 'ČEBELJELIKO MAČJE UHO',
          latinName: 'Ophrys apifera',
          image: 'https://adi.dobra-pot.si/orchids/2_bee_orchid.jpg'
        },
        {
          id: 3,
          name: 'Burnt orchid',
          siName: 'PIKASTOCVETNA KUKAVICA',
          latinName: 'Neotinea ustulata, Orchis ustulata',
          image: 'https://adi.dobra-pot.si/orchids/3_burnt orchid.jpg'
        },
        {
          id: 4,
          name: 'Round-headed orchid',
          siName: 'NAVADNA OBLASTA KUKAVICA',
          latinName: 'Traunsteinera globosa',
          image: 'https://adi.dobra-pot.si/orchids/4_round_headed_orchid.jpg'
        },
        {
          id: 5,
          name: 'Military orchid',
          siName: 'ČELADASTA KUKAVICA',
          latinName: 'Orchis militaris',
          image: 'https://adi.dobra-pot.si/orchids/5_military_orchid.jpg'
        },
        {
          id: 6,
          name: 'Fragrant orchid',
          siName: 'NAVADNI KUKOVIČNIK',
          latinName: 'Gymnadenia conopsea',
          image: 'https://adi.dobra-pot.si/orchids/6_fragrant_orchid.jpg'
        },
        {
          id: 7,
          name: 'Fly orchid',
          siName: 'MUHOLIKO MAČJE UHO',
          latinName: 'Ophrys insectifera',
          image: 'https://adi.dobra-pot.si/orchids/7_ fly_orchid.jpg'
        },
        {
          id: 8,
          name: 'Common spotted orchid',
          siName: 'FUCHSOVA PRSTASTA KUKAVICA',
          latinName: 'Dactylorhiza fuchsii',
          image: 'https://adi.dobra-pot.si/orchids/8_common_spotted_orchid.jpg'
        },
        {
          id: 9,
          name: 'Three-toothed orchid',
          siName: 'TRIZOBA KUKAVICA',
          latinName: 'Neotinea tridentata, Orchis tridentata',
          image: 'https://adi.dobra-pot.si/orchids/9_three_toothed_orchid.jpg'
        },
        {
          id: 10,
          name: 'Lady orchid',
          siName: 'ŠKRLATNORDEČA KUKAVICA',
          latinName: 'Orchis purpurea',
          image: 'https://adi.dobra-pot.si/orchids/10_lady_orchid.jpg'
        },
        {
          id: 11,
          name: 'Early purple orchid',
          siName: 'ZVEZDNATA KUKAVICA',
          latinName: 'Orchis mascula - speciosa',
          image: 'https://adi.dobra-pot.si/orchids/11_early_purple_orchid.jpg'
        },
        {
          id: 12,
          name: 'Green-winged orchid',
          siName: 'NAVADNA KUKAVICA',
          latinName: 'Anacamptis morio, Orchis morio',
          image: 'https://adi.dobra-pot.si/orchids/12_green_winged_orchid.jpg'
        },
        {
          id: 13,
          name: 'Lesser butterfly-orchida',
          siName: 'DVOLISTNI VIMENJAK',
          latinName: 'Platanthera bifolia',
          image: 'https://adi.dobra-pot.si/orchids/13_lesser_butterfly_orchid.jpg'
        },
        {
          id: 14,
          name: 'Bird\'s-nest orchid',
          siName: 'RJAVA GNEZDOVNICA',
          latinName: 'Neottia nidus-avis',
          image: 'https://adi.dobra-pot.si/orchids/14_birds_nest_orchid.jpg'
        },
        {
          id: 15,
          name: 'White helleborine',
          siName: 'BLEDA NAGLAVKA',
          latinName: 'Cephalanthera damasonium',
          image: 'https://adi.dobra-pot.si/orchids/15_white_helleborine_orchid.jpg'
        },
        {
          id: 16,
          name: 'Common twayblade',
          siName: 'JAJČASTOLISTNI MUHOVNIK',
          latinName: 'Neottia ovata, Listera ovata',
          image: 'https://adi.dobra-pot.si/orchids/16_common_twayblade_orchid.jpg'
        },
        {
          id: 17,
          name: 'Pyramidal orchid',
          siName: 'PIRAMIDASTI PILOVEC',
          latinName: 'Anacamptis pyramidalis',
          image: 'https://adi.dobra-pot.si/orchids/17_pyramidal_orchid.jpg'
        },
        {
          id: 18,
          name: 'Violet limodore',
          siName: 'NAVADNA SPLAVKA',
          latinName: 'Limodorum abortivum',
          image: 'https://adi.dobra-pot.si/orchids/18_violet_limodore_orchid.jpg'
        },
        {
          id: 19,
          name: 'Sword-leaved helleborine, Narrow-leaved helleborine',
          siName: 'DOLGOLISTNA NAGLAVKA',
          latinName: 'Cephalanthera longifolia',
          image: 'https://adi.dobra-pot.si/orchids/19_helleborine_orchid.jpg'
        },
        {
          id: 20,
          name: 'Greater butterfly orchid',
          siName: 'ZELENKASTI VIMENJAK',
          latinName: 'Platanthera chlorantha',
          image: 'https://adi.dobra-pot.si/orchids/20_greater_butterfly_orchid.jpg'
        },
        {
          id: 21,
          name: 'The pale orchid',
          siName: 'BLEDA KUKAVICA',
          latinName: 'Orchis pallens',
          image: 'https://adi.dobra-pot.si/orchids/21_bleda_kukavica.jpg'
        },
        {
          id: 22,
          name: 'The monkey orchid',
          siName: 'OPIČJA KUKAVICA',
          latinName: 'Orchis simia',
          image: 'https://adi.dobra-pot.si/orchids/22_opicja_kukavica.jpg'
        },
        {
          id: 23,
          name: 'Elder flowered orchid',
          siName: 'BEZGOVA PRSTASTA KUKAVICA',
          latinName: 'Dactylorhiza sambucina',
          image: 'https://adi.dobra-pot.si/orchids/23_bezgova_prstasta_kukavica.jpg'
        },
        {
          id: 24,
          name: 'Bug orchid',
          siName: 'STENIČJA KUKAVICA',
          latinName: 'Anacamptis coriophora',
          image: 'https://adi.dobra-pot.si/orchids/24_stenicja_kukavica.jpg'
        },
        {
          id: 25,
          name: 'Red helleborine',
          siName: 'RDEČA NAGLAVKA',
          latinName: 'Cephalanthera rubra',
          image: 'https://adi.dobra-pot.si/orchids/25_rdeca_naglavka.jpg'
        },
        {
          id: 26,
          name: 'Royal helleborine',
          siName: 'TEMNORDEČA MOČVIRNICA',
          latinName: 'Epipactis atrorubens',
          image: 'https://adi.dobra-pot.si/orchids/26_temnordeca_mocvirnica.jpg'
        },
        {
          id: 27,
          name: 'Lady\'s slipper orchid',
          siName: 'LEPI ČEVELJC',
          latinName: 'Cypripedium calceolus',
          image: 'https://adi.dobra-pot.si/orchids/27_lepi_ceveljc.jpg'
        },
        {
          id: 28,
          name: 'Early coralroot',
          siName: 'TROKRPI KORALASTI KOREN',
          latinName: 'Corallorhiza trifida',
          image: 'https://adi.dobra-pot.si/orchids/28_trokrpi_koralasti_koren.jpg'
        },
        {
          id: 29,
          name: 'Autumn Ladies-tresses',
          siName: 'ZAVITA ŠKRBICA',
          latinName: 'Spiranthes spiralis',
          image: 'https://adi.dobra-pot.si/orchids/29_zavita_skrbica.jpg'
        },
      ],
      colorsOptions: [
        {
          id: 1,
          name: 'white',
          siName: 'bela',
          hex: 'n/a'
        },
        {
          id: 2,
          name: 'purple',
          siName: 'vijoličasta',
          hex: 'n/a'
        },
        {
          id: 3,
          name: 'dark/reddish purple',
          siName: 'temno/rdeče vijoličasta',
          hex: 'n/a'
        },
        {
          id: 4,
          name: 'pink',
          siName: 'rozna',
          hex: 'n/a'
        },
        {
          id: 5,
          name: 'light pink',
          siName: 'svetlo rozna',
          hex: 'n/a'
        },
        {
          id: 6,
          name: 'light pink and dotted',
          siName: 'svetlo rozna in pikčasta',
          hex: 'n/a'
        },
        {
          id: 7,
          name: 'pink and dotted',
          siName: 'rozna in pikčasta',
          hex: 'n/a'
        },
        {
          id: 8,
          name: 'pink and reddish brown',
          siName: 'vijoličasta in rdečkasto rjava',
          hex: 'n/a'
        },
        {
          id: 9,
          name: 'white and purple',
          siName: 'bela in vijoličasta',
          hex: 'n/a'
        },
        {
          id: 10,
          name: 'green',
          siName: 'zelena',
          hex: 'n/a'
        },
        {
          id: 11,
          name: 'green and white',
          siName: 'zelena in bela',
          hex: 'n/a'
        },
        {
          id: 12,
          name: 'green and reddish brown',
          siName: 'zelena in rdečkasto rjava',
          hex: 'n/a'
        },
        {
          id: 13,
          name: 'brown',
          siName: 'rjava',
          hex: 'n/a'
        },
        {
          id: 14,
          name: 'yellow',
          siName: 'rumena',
          hex: 'n/a'
        },
      ],
    }
  },
  computed: {
    getColorsOptions() {
      return _.orderBy(this.colorsOptions, ['name'],['asc']);
    }
  },
  mounted() {
    const _this = this

    if (_this.id) {
      _this.editMode = true
      _this.loadOrchid()
    } else {
      _this.editMode = false
      _this.deviceUuid = new DeviceUUID.DeviceUUID().get();
      console.log("_this.deviceUuid", _this.deviceUuid);
    }

  },
  methods: {
    loadOrchid() {
      const _this = this;

      db.collection('orchids')
          .doc(this.id)
          .get()
          .then(snapshot => {
            const document = snapshot.data();
            console.log("document,", document);
            _this.site = document.site;
            _this.deviceUuid = document.createdBy ? document.createdBy : new DeviceUUID.DeviceUUID().get();
            _this.species = document.species;
            _this.height = document.height;
            _this.color = document.color;
            _this.count = document.count;
            _this.latitude = document.latitude;
            _this.longitude = document.longitude;
            _this.comment = document.comment;
            _this.imageUrl = document.photo;
            _this.imageName = document.photo;
          });

    },

    clearData() {
      const _this = this;

      console.log("clearData");

      _this.id = null;
      _this.site = null;
      _this.species = null;
      _this.height = null;
      _this.color = null;
      _this.count = null;
      _this.latitude = null;
      _this.longitude = null;
      _this.comment = null;

      _this.imageName = null;
      _this.imageFile = null;
      _this.imageUrl = null;

      window.scrollTo(0, 0);

      _this.$forceUpdate();

      _this.$nextTick(() => {
        _this.errors.clear();
        _this.$nextTick(() => {
          _this.$validator.reset();
        });
      });
    },

    getCurrentPosition() {
      const _this = this;

      _this.isLoading = true;

      _this.$getLocation({
        enableHighAccuracy: true, //defaults to false
      })
          .then(coordinates => {
            _this.latitude = coordinates.lat;
            _this.longitude = coordinates.lng;
            console.log("coordinates", coordinates);
            _this.isLoading = false;
          });
    },

    onPlaceChanged(res) {
      const _this = this

      console.log(res)
      _this.event.municipality = _this.getGeocompleteData(res, 'administrative_area_level_1')
      _this.event.address = res.formatted_address
    },
    getOptionLabel(option) {
      console.log(option)
      return this.getReadableUser(option.id)
    },

    showOrchidsPicker() {
      const _this = this
      this.$refs['orchidsPickerModal'].show()
    },


    async updateData() {
      const _this = this
      const currentOrchid = db.collection('orchids').doc(this.id)

      // await _this.validateFields()
      //
      // if (_this.errors.items.length > 0) {
      //   await _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true})
      //   return false
      // }

      return currentOrchid.update({
        createdAt: _this.createdAt,
        updatedAt: new Date(),
        createdBy: _this.deviceUuid,
        id: _this.id,
        site: _this.site,
        species: _this.species,
        height: parseInt(_this.height),
        color: _this.color,
        count: parseInt(_this.count),
        latitude: _this.latitude,
        longitude: _this.longitude,
        comment: _this.comment,
        photo: _this.imageUrl
      })
          .then(function () {

            _this.isLoading = false;

            _this.$swal({
              title: 'Orchid data successfully saved!',
              text: 'Keep up the good work!',
              dangerMode: false,
              buttons: {
                confirm: {
                  text: 'OK',
                  value: true,
                  visible: true,
                  className: '',
                  closeModal: true
                }
              },
            })
                .then((value) => {

                  switch (value) {

                    case true:

                      _this.clearData();

                    case null:

                      return

                      break

                    default:

                  }
                })


          })
          .catch(function (error) {
            _this.isLoading = false;
            // The document probably doesn't exist.
            _this.$swal('Error :(', 'Please try again!', 'error', {dangerMode: true})
            console.error('Error updating event: ', error)
          })

    },

    async saveData() {
      const _this = this

      await _this.validateFields();

      if (_this.errors.items.length > 0) {
        _this.$swal('Required data missing!', 'Please check your inputs!', 'error', {dangerMode: true})
        return
      }

      _this.isLoading = true;
      window.scrollTo(0, 0);

      if(_this.id) {
        _this.updateData();
        return;
      }

      _this.uploadImage().then((res) => {
        console.log("res", res);
        let ref = db.collection('orchids').doc()
        ref.set({id: ref.id}) // set new document ID
            .then(() => {  // fetch the doc again and show its data
              ref.get().then(doc => {
                _this.id = doc.data().id;
                _this.createdAt = new Date();
                console.log("doc.data()", doc.data());
                console.log("_this.id", _this.id)
                _this.updateData()
              })
            })


      });



    },

    async validateFields() {
      let _this = this

      await _this.$validator.validate('site', _this.site);
      await _this.$validator.validate('species', _this.species);
      await _this.$validator.validate('height', _this.height);
      await _this.$validator.validate('color', _this.color);
      await _this.$validator.validate('count', _this.count);
      await _this.$validator.validate('latitude', _this.latitude);
      await _this.$validator.validate('longitude', _this.longitude);
      await _this.$validator.validate('imageName', _this.imageName);
    },

    pickFile() {
      this.$refs.image.click();
    },

    onFilePicked(e) {
      const _this = this;

      const files = e.target.files;
      if (files[0] !== undefined) {
        _this.imageName = _this.moment().valueOf() + '_' + files[0].name;
        if (_this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          _this.imageUrl = fr.result;
          //console.log("imageUrl");
          _this.imageFile = files[0]; // this is an image file that can be sent to server...
          //this.getImages();
        });
      } else {
        _this.imageName = null;
        _this.imageFile = null;
        _this.imageUrl = null;
      }
    },


    async uploadImage() {
      const _this = this;

      const storageRef = await firebase
          .storage()
          .ref()
          .child(`orchids/${_this.imageName}`)
          .put(_this.imageFile)

          .then(snapshot => {
              snapshot.ref.getDownloadURL().then(downloadURL => {
                _this.imageUrl = downloadURL;
              });
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            _this.isLoading = false;
            _this.$swal('Error :(', 'Could not upload the photo. Please try again!', 'error', {dangerMode: true})
            console.error('Error updating event: ', error)
          });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/List.vue